import { InvokeApi } from "../../Utils/InvokeApi";

export const CreateLaguage = async (data) => {
  const requestObj = {
    path: `/language/create`,
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    postData: data,
  };
  return InvokeApi(requestObj);
};

export const UpdateLaguage = async (languageId, data) => {
    const requestObj = {
      path: `/language/${languageId}`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      postData: data,
    };
    return InvokeApi(requestObj);
  };
  

export const GetLanguage = async (data) => {
   const { page, limit, key, value } = data;
  const params = new URLSearchParams();
  if (data !== false) {
    params.set('page', page.toString());
    params.set('limit', limit.toString());
  // Only include key and value if both are provided
  if (key && value) {
    params.set('key', key);
    params.set('value', value);
  }
}
  let paramQuery = data !== false ? params.toString() : ""
  const requestObj = {
    path: `/language/get?${paramQuery}`,
    method: "GET",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
      "Content-Type": "application/json",
    },
  };
  return InvokeApi(requestObj);
};

export const DeleteLanguage = async (languageId) => {
    const requestObj = {
      path: `/language/${languageId}`,
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("admin_token")}`,
        "Content-Type": "application/json",
      },
    };
    return InvokeApi(requestObj);
};

